<template>
  <div class="WidgetRecoCard">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(reco_data, index) in recommendationsList" :key="index" v-if="isDesktopExpertView">
        <el-card class="box-card" v-loading="reco_data.is_loading">
          <div v-loading="reco_data.is_strategy_loading" style="position: relative">
            <div
              :style="[
                index != 0
                  ? {
                      pointerEvents: 'none',
                    }
                  : 'pointer',
              ]"
            >
              <div class="flex-space-between border-bottom-gray">
                <div style="width: 60%">
                  <div class="flex flex-space-between" style="width: 100%">
                    <div>
                      <span class="stock-title cursor-pointer">{{ reco_data.stock.name }}</span>
                      <img class="info-Logo cursor-pointer" src="../../assets/images/Info.svg" style="width: 15px; top: 4px; left: 2px" alt @click="loadTradingViewWidget(reco_data.stock.symbol)" />
                      &nbsp;
                    </div>
                  </div>

                  <div class="top-margin-5">
                    <el-row>
                      <el-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13" class="margin-right-20">
                        <span v-if="reco_data.stock.current_price">
                          <span class="estimate-value right-margin-10" title="Current price">₹ {{ reco_data.stock.current_price }}</span>

                          <span class="top-margin-10 stock-section-inc" :style="[reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                            <span style="font-size: 18px" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
                            <span style="font-size: 18px" v-else>&#9662;</span>
                            {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
                          </span>
                        </span>
                        <span class="estimate-value right-margin-10" title="Current price" v-else>NA</span>
                        <span>
                          <img
                            class="info-Logo cursor-pointer"
                            src="../../assets/images/Fundamental analysis.svg"
                            alt
                            @click="
                              selectedSymbol = reco_data.stock.symbol;
                              showSentimentCard = true;
                            "
                          />

                           <el-popover
  placement="bottom"
  trigger="click"
  width="300"
  popper-class="custom-popover-shadow"
  style="margin-bottom: 4px"
>
  <img
    class="info-Logo cursor-pointer"
    src="../../assets/images/Logic.svg"
    alt
    slot="reference"
  />

  <div class="recommendation-details">
    <el-collapse v-model="activeLogicSections" accordion>
      <!-- Discovery Category & Logic -->
      <el-collapse-item name="1" title="Discovery Category & Logic">
        <div
          v-if="reco_data.category_stamp && reco_data.category_stamp.length"
          style="border-bottom:1px solid rgb(231, 231, 231); margin-bottom: 10px; padding-top: 5px;"
        >
          <div class="section-subtitle">Category</div>
          <div class="category-list">
            <span
              v-for="(stamp, index) in reco_data.category_stamp"
              :key="index"
              class="category-chip"
            >
              {{ stamp }}
            </span>
          </div>
        </div>

        <div
          v-if="reco_data.report && reco_data.report.some(item => item.files && item.files.length)"
        >
          <div
            v-for="(item, item_index) in reco_data.report"
            :key="item_index"
          >
            <div
              v-for="(attachment, attachment_index) in item.files"
              :key="attachment_index"
              class="attachment-block"
            >
              <div class="attachment-header">
                <div class="attachment-title">
                  Attachments {{ attachment_index + 1 }}
                </div>
                <div
                  class="download-link"
                  @click="downloadAttachment(attachment)"
                >
                  <i class="el-icon-download"></i> Download
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="reco_data.logic_description || (reco_data.logic_tags && reco_data.logic_tags.length)"
          class="section-block"
          :style="(reco_data.edit_description || reco_data.exit_description) ? 'border-bottom:1px solid rgb(231, 231, 231); padding-bottom: 10px; padding-top: 5px;' : 'padding-bottom: 10px; padding-top: 5px;'"
        >
          <div class="section-subtitle">Logic</div>
          <div class="logic-description">
            {{ reco_data.logic_description }}
          </div>
          <div
            class="logic-tags"
            v-if="reco_data.logic_tags && reco_data.logic_tags.length"
          >
            <span
              v-for="(tag, i) in reco_data.logic_tags"
              :key="i"
              class="logic-tag"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </el-collapse-item>

      <!-- Updated Logic -->
      <el-collapse-item
        name="2"
        title="Updated Logic"
        v-if="reco_data.edit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.edit_description }}
          </div>
        </div>
      </el-collapse-item>

      <!-- Exit Logic -->
      <el-collapse-item
        name="3"
        title="Exit Logic"
        v-if="reco_data.exit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.exit_description }}
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</el-popover>
                        </span>

                        <div class="input-label-gray" style="font-size: 10px" v-if="reco_data.stock.current_datetime">
                          {{ reco_data.stock.current_datetime | stock_live_price_date_filter }}
                        </div>
                      </el-col>

                      <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" class="top-margin-10 flex">
                        <el-tag size="mini" class="right-margin-10 sector-tag" effect="plain" title="Market size" type="info" v-if="reco_data.stock.market_cap">
                          {{ reco_data.stock.market_cap }}
                        </el-tag>

                        <el-tag size="mini" class="right-margin-10 sector-tag" effect="plain" title="Sector" type="info" v-if="reco_data.stock.sector">
                          {{ reco_data.stock.sector }}
                        </el-tag>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="reco-date-mobile bottom-margin-10 top-margin-10 text-right" style="width: 40%">
                  <label class="input-label-gray flex-end" style="font-size: 11px">
                    Reco Date :
                    {{ reco_data.created_at | stock_live_price_date_filter }}
                    <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 1px"></span>
                  </label>

                  <div class="flex-end top-margin-5">
                    <span class="font-08rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>
                  </div>
                </div>
              </div>

              <el-row class="top-margin-15 reco-details">
                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="border-right: 1px solid #ddd; height: 112px">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="flex-space-between profile-antestimateSection bottom-margin-10">
                        <div class="flex" style="align-items: unset">
                          <img v-if="!reco_data.user.pic || reco_data.filtered_by == 'company'" src="../../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

                          <img v-else :src="serverHostName + reco_data.user.pic" class="user-profile-pic" alt />

                          <div class="company-employee-details">
                            <div class="label-lg-black-bold right-margin-3" :style="[$router.currentRoute.path == '/experts-past-recommendations' ? { cursor: 'pointer' } : { cursor: 'text' }]" style="text-transform: capitalize; font-size: 14px">
                              <span v-if="reco_data.filtered_by == 'company'">{{ reco_data.user.company.name }}</span>
                              <span v-else>{{ reco_data.user.full_name }}</span>
                              <el-tooltip v-if="reco_data.user.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                                <img class="info-Logo cursor-pointer" src="../../assets/images/verify.svg" style="width: 16px" alt />
                              </el-tooltip>
                            </div>

                            <span v-if="reco_data.filtered_by == 'company'">
                              <span class="right-margin-3 input-label-gray">{{ reco_data.user.full_name }} -</span>
                              <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
                            </span>

                            <span v-if="reco_data.filtered_by != 'company'">
                              <span class="right-margin-3 input-label-gray" v-if="reco_data.user.company && reco_data.user.profession != 'Student'">{{ reco_data.user.company.name }} -</span>

                              <span class="right-margin-3 input-label-gray" v-if="reco_data.user.profession == 'Student' && reco_data.user.institute_name">{{ reco_data.user.institute_name }} -</span>

                              <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
                            </span>

                            <img v-if="reco_data.source == 'marketplace'" src="../../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px" />

                            <br />

                            <span class="right-margin-3 input-label-gray">
                              Total Recommendation -
                              <span class="input-label-bold-gray">
                                {{ reco_data.user.total_reco ? reco_data.user.total_reco : 0 }}
                              </span>
                            </span>
                            <br />
                          </div>
                        </div>

                        <div class="period-contents mobile-blocks antestimate-mobile">
                          <div class="antestimate-block" v-if="reco_data.antestimate_number && reco_data.reco_status != 'CLOSED'">
                            <label class="label-xs-bold">
                              Antestimate
                              <el-popover placement="bottom" title="Antestimate" width="225" trigger="click" content="Aggregated price estimates of users (only for short term)">
                                <span slot="reference" style="padding: 0px 2px 0px 4px; background: #ffff; color: rgb(0, 0, 0); border-radius: 50%; font-size: 9px; margin-right: 5px">i</span>
                              </el-popover>
                            </label>
                            <span class="bottom-margin-10 label-xs-bold">: {{ reco_data.antestimate_number }}</span>
                          </div>

                          <div class="compare-expert-dropdown-container" v-if="reco_data.reco_status != 'CLOSED' && reco_data.antestimate_number">
                            <el-select v-model="reco_data.expert" placeholder="Compare With Expert" size="mini" @focus="getMarketExpertList(reco_data.id, index)">
                              <el-option v-if="reco_data.expert_list && reco_data.expert_list.length" value="" label="" style="pointer-events: none; border-bottom: 1px solid #eee" :style="[screenOuterSize < 575 ? { width: '350px' } : { width: '510px' }]">
                                <div class="flex-space-between">
                                  <div style="width: 25%; color: #606266; font-weight: 600">Name</div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 600; padding: 0 10px">Target Price</div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 600; padding: 0 10px">Reco</div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 600">Status</div>
                                </div>
                              </el-option>

                              <el-option v-for="(expert, expertIndex) in reco_data.expert_list" :key="expertIndex" :label="expert.user.full_name" :value="expertIndex" class="capitalize" style="width: 400px" :style="[screenOuterSize < 575 ? { width: '350px' } : { width: '510px' }]">
                                <div class="flex-space-between" v-if="reco_data.expert_list && reco_data.expert_list.length">
                                  <div
                                    class="font-08rem"
                                    style="width: 25%; color: #606266; font-weight: 400"
                                    :style="[
                                      screenOuterSize < 850
                                        ? {
                                            textOverlflow: 'ellipsis',
                                            overflow: 'hidden',
                                            whiteSpace: 'no-wrap',
                                          }
                                        : {},
                                    ]"
                                  >
                                    {{ expert.user.full_name }}
                                  </div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 400; padding: 0 10px">
                                    ₹ {{ expert.target_price }}
                                    <span class="font-06rem">({{ expert.target_potential }}%)</span>
                                  </div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 400; padding: 0 10px" :style="[expert.reco == 'Buy' ? { color: '#079e3e' } : expert.reco == 'Sell' ? { color: '#d60918' } : { color: '#e2ba00' }]">
                                    {{ expert.reco }}
                                  </div>

                                  <div class="font-07rem text-center" style="width: 25%; color: #606266; font-weight: 400">
                                    {{ expert.reco_status }}
                                  </div>
                                </div>
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="faded-border-bottom target-period-section-border">&nbsp;</div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <el-row class="performance-accuracy-container">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="performance-section">
                        <el-tooltip class="item" effect="dark" :disabled="reco_data.reco_status == 'YET TO LIVE'" :content="reco_data.reco_status == 'TARGET ACHIEVED' ? 100 + '%' : reco_data.performance + '%'" placement="top">
                          <NewCircleProgress :transitionDuration="5000" :radius="44" :strokeWidth="10" :strokeColor="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? '#079e3e' : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? '#d60918' : '#079e3e'" :value="getPerformanceWheelValue(reco_data) > 100 ? 100 : getPerformanceWheelValue(reco_data)">
                            <div class style="font-size: 0.6rem">
                              {{ reco_data.reco_status }}
                            </div>
                            <template v-slot:footer></template>
                          </NewCircleProgress>
                        </el-tooltip>

                        <div class="progress-description">
                          <div class="input-label-bold-gray">
                            <span v-if="reco_data.reco_status == 'CLOSED'">
                              As on
                              {{ reco_data.closed_date_time | formatDate }}
                            </span>

                            <span v-if="reco_data.reco_status == 'TARGET ACHIEVED'">
                              As on
                              {{ reco_data.target_achieved_date_time | formatDate }}
                            </span>

                            <span v-if="reco_data.reco_status == 'TARGET NOT ACHIEVED'">
                              As on
                              {{ reco_data.target_not_achieved_date_time | formatDate }}
                            </span>

                            <span v-if="reco_data.reco_status == 'STOP LOSS TRIGGERED'">
                              As on
                              {{ reco_data.stop_loss_triggered_date_time | formatDate }}
                            </span>

                            <span v-if="reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'UPDATED'">As on {{ reco_data.stock.today | formatDate }}</span>

                            <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED') && reco_data.difference_in_days == 0">(Today)</div>

                            <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days != 0">
                              ({{ reco_data.difference_in_days }}
                              <span v-if="reco_data.difference_in_days > 1">Days</span>
                              <span v-else>Day</span>
                              from reco date)
                            </div>

                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days == 0">(Updated Today)</div>

                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days != 0">
                              ({{ reco_data.difference_in_days }}
                              <span v-if="reco_data.difference_in_days > 1">Days</span>
                              <span v-else>Day</span>
                              from updated reco date)
                            </div>

                            <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days == 0">(On Reco date)</div>

                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.has_close_reco && reco_data.difference_in_days == 0 && reco_data.reco_status == 'TARGET ACHIEVED'">(On Updated Reco date)</div>

                            <div class="progress-bar-legends-section top-margin-20" style="flex-direction: column">
                              <div class="flex">
                                <div class="progress-bar-legends" :style="[(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? { 'background-color': '#079e3e' } : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? { 'background-color': '#d60918' } : reco_data.reco_status == 'TARGET ACHIEVED' ? { 'background-color': '#079e3e' } : { 'background-color': '#a29eab' }]">&nbsp;</div>
                                <div class="legends-text input-label-xs-bold-black">Performance</div>
                              </div>
                              <div class="flex top-margin-5">
                                <div class="progress-bar-legends">&nbsp;</div>
                                <div class="legends-text input-label-xs-bold-black">Potential</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                  <div class="left-margin-20">
                    <div class="remaining-potential remaining-potential-desktop roi-card-main">
                      <div class="roi-card">
                        <div class="input-label-bold-gray" style="margin: 0">
                          Remaining Target
                          <el-popover placement="bottom" title="Potential" width="200" trigger="click" content="It is calculated on basis of minimum investment of Rs. 1 Lakh which can incurred on the basis of last tracked price">
                            <img class="info-Logo cursor-pointer" src="../../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
                          </el-popover>
                        </div>
                        <div class="label-md-bold-black top-margin-5" style="color: #079e3e">
                          <span style="margin-left: 5px">
                            <span v-if="reco_data.reco_status == 'YET TO LIVE'">{{ reco_data.max_profit_in_percentage }}%</span>
                            <span v-else-if="reco_data.reco_status == 'TARGET ACHIEVED'">0%</span>
                            <span v-else>{{ !reco_data.potential_as_of_current_date ? 0 : reco_data.potential_as_of_current_date }}%</span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="flex left-margin-5 top-margin-20">
                      <div class="period-type-tag" style="width: 47%; margin-left: 10px" :class="[reco_data.reco == 'Buy' ? 'active-period-type-tag' : reco_data.reco == 'Sell' ? 'active-period-type-tag-red' : reco_data.reco == 'Hold' ? 'active-period-type-tag-yellow' : 'period-type-tag']">
                        <img style="width: 14px; margin-right: 6px; position: relative; top: 3px" src="../../assets/images/two-arrows.png" alt="" />
                        {{ reco_data.reco }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="flex flex-center">
                <span class="input-label-gray cursor-pointer" style="color: red; margin: 10px 0px" icon @click="toggleMoreInfo(index)" v-if="reco_data.toggle_more_info">
                  Less details
                  <i class="el-icon-arrow-up"></i>
                </span>

                <span class="input-label-gray cursor-pointer" style="color: red; margin: 10px 0px; text-transform: capitalize" icon @click="toggleMoreInfo(index)" v-else>
                  {{ reco_data.user.first_name ? reco_data.user.first_name + "'s" : reco_data.user.full_name ? reco_data.user.full_name.split(' ')[0] + "'s" : '' }}
                  reco details
                  <i class="el-icon-arrow-down"></i>
                </span>
              </div>

              <div class="faded-border-bottom">&nbsp;</div>

              <el-row :gutter="20" class="top-margin-20" v-if="reco_data.toggle_more_info">
                <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">&nbsp;</el-col>

                <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px">
                  <StockProgress :stockData="reco_data" :selectedIndex="index" :segment="'Equity'"></StockProgress>
                </el-col>
              </el-row>

              <div class="top-margin-20" v-if="reco_data.toggle_more_info && reco_data.closed_reco_list && reco_data.closed_reco_list.length" v-loading="reco_data.closed_reco_list_loading">
                <div class="faded-border-bottom">&nbsp;</div>

                <div class="label-md-bold-black top-margin-10">Previous recommendations</div>
                <div v-for="(item, itemIndex) in reco_data.closed_reco_list" :key="itemIndex">
                  <el-row :gutter="20" class="top-margin-20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div style="margin: 2px 0" v-if="itemIndex == reco_data.closed_reco_list.length - 1">
                        <div class="label-xs-bold" style="font-size: 12px">
                          Original reco date :
                          {{ item.created_at | close_reco_date_filter }}
                        </div>
                      </div>

                      <div style="margin: 2px 0" v-if="itemIndex < reco_data.closed_reco_list.length - 1">
                        <div class="label-xs-bold" style="font-size: 12px">
                          Updated on :
                          {{ item.closed_date_time | close_reco_date_filter }}
                        </div>
                      </div>

                      <div class="reco-more-details-container isDeskTopView" style="border-right: 8px solid #d60918">
                        <div class="vertical-flex">
                          <label class="input-label-gray">RECO</label>
                          <span class="label-xs-bold uppercase" :style="[item.reco == 'Buy' ? { color: '#079e3e' } : item.reco == 'Sell' ? { color: '#d60918' } : { color: '#e2ba00' }]">{{ item.reco }}</span>
                        </div>

                        <div>
                          <div>
                            <label class="input-label-gray">Reco Date</label>
                            <div class="label-xs-bold">
                              {{ item.created_at | formatDate }}
                            </div>
                          </div>

                          <div class="top-margin-10">
                            <label class="input-label-gray">Reco Price</label>
                            <div class="label-xs-bold">₹ {{ item.reco_open_price }}</div>
                          </div>
                        </div>

                        <div class="vertical-flex">
                          <label class="input-label-gray">Performance</label>
                          <span class="label-lg-bold" :style="[item.reco_status == 'CLOSED' && item.performance > 0 ? { color: '#079e3e' } : item.reco_status == 'CLOSED' && item.performance < 0 ? { color: '#d60918' } : { color: '#a29eab' }]">{{ !item.performance ? 0 : item.performance }}%</span>
                        </div>

                        <div>
                          <div>
                            <label class="input-label-gray">Last Tracked Date</label>
                            <div class="label-xs-bold">
                              {{ item.closed_date_time | formatDate }}
                            </div>
                          </div>
                          <div class="top-margin-10">
                            <label class="input-label-gray">Last Tracked Price</label>
                            <div class="label-xs-bold">
                              ₹
                              {{ item.reco_status == 'CLOSED' ? item.closed_price : item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
                            </div>
                          </div>
                        </div>

                        <div class="vertical-flex">
                          <label class="input-label-gray">Potential</label>
                          <div class="label-lg-bold" style="color: #979797">{{ !item.potential_as_of_current_date ? 0 : item.potential_as_of_current_date }}%</div>
                        </div>

                        <div>
                          <div>
                            <label class="input-label-gray">Target Period</label>
                            <div class="label-xs-bold">
                              {{ item.target_period }}
                            </div>
                          </div>
                          <div class="top-margin-10">
                            <label class="input-label-gray">Target Price</label>
                            <div class="label-xs-bold">
                              ₹ {{ item.target_price }}
                              <span class="input-label-gray" style="font-size: 11px">({{ item.target_potential }}%)</span>
                            </div>
                          </div>
                        </div>

                        <div class="vertical-flex">
                          <label class="input-label-gray">STATUS</label>
                          <div class="label-xs-bold" style="color: #d60918">CLOSED</div>
                        </div>
                      </div>

                      <div class="isMobileView" style="margin-top: 0px; padding: 8px; border: 1px solid #ddd; border-radius: 18px; border-right: 6px solid #d60918">
                        <div class="flex-center">
                          <label class="input-label-gray">RECO -</label>
                          &nbsp;
                          <span class="label-xs-bold uppercase" :style="[item.reco == 'Buy' ? { color: '#079e3e' } : item.reco == 'Sell' ? { color: '#d60918' } : { color: '#e2ba00' }]">{{ item.reco }}</span>
                        </div>

                        <div style="display: flex; justify-content: space-around" class="top-margin-10">
                          <div class="col1" style="display: flex">
                            <div class="row1">
                              <div v-if="itemIndex == 0">
                                <label class="input-label-gray">Reco Date</label>
                                <div class="label-xs-bold">
                                  {{ item.created_at | formatDate }}
                                </div>
                              </div>

                              <div v-if="itemIndex > 0">
                                <label class="input-label-gray">Reco Date</label>
                                <div class="label-xs-bold">
                                  {{ item.closed_date_time | formatDate }}
                                </div>
                              </div>

                              <div>
                                <label class="input-label-gray">Last Tracked Date</label>
                                <div class="bottom-margin-10 label-xs-bold">
                                  {{ item.closed_date_time | formatDate }}
                                </div>
                              </div>

                              <div>
                                <label class="input-label-gray">Target Period</label>
                                <div class="bottom-margin-10 label-xs-bold">
                                  {{ item.target_period }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col2">
                            <div class="row2">
                              <div>
                                <label class="input-label-gray">Reco Price</label>
                                <div class="bottom-margin-10 label-xs-bold">₹ {{ item.reco_open_price }}</div>
                              </div>

                              <div>
                                <label class="input-label-gray">Last Tracked Price</label>
                                <div class="bottom-margin-10 label-xs-bold">
                                  ₹
                                  {{ item.reco_status == 'CLOSED' ? item.closed_price : item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.stock.current_price }}
                                </div>
                              </div>

                              <div>
                                <label class="input-label-gray">Target Price</label>
                                <div class="bottom-margin-10 label-xs-bold">
                                  ₹ {{ item.target_price }}
                                  <span class="input-label-gray" style="font-size: 11px">({{ item.target_potential }}%)</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col3 vertical-flex">
                            <label class="input-label-gray">Performance</label>
                            <div class="label-lg-bold" :style="[item.reco_status == 'CLOSED' || (item.reco_status == 'EXIT' && item.performance > 0) ? { color: '#079e3e' } : (item.reco_status == 'CLOSED' || item.reco_status == 'EXIT') && item.performance < 0 ? { color: '#d60918' } : { color: '#a29eab' }]">{{ !item.performance ? 0 : item.performance }}%</div>

                            <label class="input-label-gray">Potential</label>
                            <div class="label-lg-bold" style="color: #979797">{{ !item.potential_as_of_current_date ? 0 : item.potential_as_of_current_date }}%</div>

                            <label class="input-label-gray">STATUS</label>
                            <div class="label-xs-bold" style="color: #d60918">CLOSED</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="relative" v-if="itemIndex < reco_data.closed_reco_list.length - 1">
                    <img src="../../assets/images/company/arrow.svg" class="vl" />
                  </div>
                </div>
              </div>

              <div v-if="reco_data.compared_experts_list.length">
                <ComparedRecommendationsOfExpert :expertsRecommendationsList="reco_data.compared_experts_list" :parentIndex="index" :recoType="recoType"></ComparedRecommendationsOfExpert>
              </div>
            </div>
            <PremiumLock v-if="index != 0"></PremiumLock>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="(reco_data, index) in recommendationsList" :key="index" v-if="!isDesktopExpertView">
        <el-card class="box-card box-card-two" v-loading="reco_data.is_loading">
          <div v-loading="reco_data.is_strategy_loading" style="position: relative">
            <div
              :style="[
                index != 0
                  ? {
                      pointerEvents: 'none',
                    }
                  : 'pointer',
              ]"
            >
              <div class="inner-card">
                <div class="reco-date-mobile text-right">
                  <label class="input-label-gray flex-end" style="font-size: 11px">
                    Reco Date :
                    {{ reco_data.created_at | stock_live_price_date_filter }}
                    <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 1px; left: 4px"></span>
                  </label>

                  <div class="flex-end">
                    <span class="font-07rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>

                    <!-- </div>
                    <div> -->
                    <span
                      class="secondary-theme-color text-right font-09rem cursor-pointer"
                      style="margin-right: 5px"
                      v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'YET TO LIVE') && $router.currentRoute.path == '/past-recommendations'"
                      @click="
                        openUpdateRecoDialog({
                          reco_data: reco_data,
                          index: index,
                        })
                      "
                    >
                      <i class="el-icon-edit"></i>
                    </span>

                    <span class="download-btn right-margin-5" style="text-align: right" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED') && $router.currentRoute.path == '/past-recommendations'" @click="exitReco(reco_data, index)">EXIT</span>
                  </div>
                </div>
                <div class="first-sec">
                  <div class="flex-space-between profile-antestimateSection bottom-margin-10 flex-wrap">
                    <div class="flex" style="align-items: unset">
                      <img v-if="!reco_data.user.pic || reco_data.filtered_by == 'company'" src="../../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

                      <img v-else :src="serverHostName + reco_data.user.pic" class="user-profile-pic" alt />

                      <!-- if current route is not expert sections route then applied cursor pointer style to expert's name -->
                      <div class="company-employee-details">
                        <div class="flex">
                          <div class="label-lg-black-bold right-margin-3" :style="[$router.currentRoute.path == '/experts-past-recommendations' ? { cursor: 'pointer' } : { cursor: 'text' }]" style="text-transform: capitalize; font-size: 14px">
                            <!-- if filtered by company id then displyaed company name other wise user name -->
                            <span v-if="reco_data.filtered_by == 'company'">{{ reco_data.user.company.name }}</span>
                            <span v-else>{{ reco_data.user.full_name }}</span>
                            <el-tooltip v-if="reco_data.user.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                              <img class="info-Logo cursor-pointer" src="../../assets/images/verify.svg" style="width: 16px" alt />
                            </el-tooltip>
                          </div>
                        </div>

                        <!-- if recos filtered by company id then displyaed their campany name followed by profession -->
                        <span v-if="reco_data.filtered_by == 'company'">
                          <span class="right-margin-3 input-label-gray">{{ reco_data.user.full_name }} -</span>
                          <span class="right-margin-3 input-label-gray">{{ reco_data.user.profession }}</span>
                        </span>

                        <span v-if="reco_data.filtered_by != 'company'" class="input-label-gray" style="font-size: 11px">
                          <span class="right-margin-3" v-if="reco_data.user.company && reco_data.user.profession != 'Student'">{{ reco_data.user.company.name }} -</span>

                          <span class="right-margin-3" v-if="reco_data.user.profession == 'Student' && reco_data.user.institute_name">{{ reco_data.user.institute_name }} -</span>

                          <span class="right-margin-3">{{ reco_data.user.profession }}</span>
                        </span>

                        <img v-if="reco_data.source == 'marketplace'" src="../../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px" />

                        <br />
                      </div>
                    </div>
                  </div>
                  <div class="reco-date-desktop text-right">
                    <label class="input-label-gray" style="font-size: 11px">
                      Reco Date :
                      {{ reco_data.created_at | stock_live_price_date_filter }}
                      <span v-if="$router.currentRoute.path != '/past-recommendations'" style="position: relative; top: 5px"></span>
                    </label>

                    <div class="flex-end">
                      <span class="font-08rem right-margin-5 font-weight-600 input-label-gray">{{ reco_data.duration == 'Long_term' ? 'Long Term' : reco_data.duration }}</span>
                    </div>
                  </div>
                </div>

                <div class="faded-border-bottom">&nbsp;</div>

                <div class="second-sec">
                  <div class="">
                    <span class="stock-title cursor-pointer">
                      {{ reco_data.stock.name }}
                    </span>
                    <img class="info-Logo cursor-pointer" src="../../assets/images/Info.svg" style="width: 15px; top: 4px; left: 2px" alt @click="loadTradingViewWidget(reco_data.stock.symbol)" />
                    &nbsp;
                  </div>
                </div>

                <div class="third-sec">
                  <el-row class="reco-details-section">
                    <el-col :xs="15" :sm="15" :md="12" :lg="12" :xl="12">
                      <el-row>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="small-box">
                          <!-- stock details section -->
                          <div class="second-sec" style="margin-top: 0">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
                                <span v-if="reco_data.stock.current_price">
                                  <span class="estimate-value right-margin-10" title="Current price">₹ {{ reco_data.stock.current_price }}</span>

                                  <span class="stock-section-inc" :style="[reco_data.stock.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                                    <span style="font-size: 18px" v-if="reco_data.stock.price_difference >= 0">&#9652;</span>
                                    <span style="font-size: 18px" v-else>&#9662;</span>
                                    {{ reco_data.stock.price_difference }} ({{ reco_data.stock.potential_difference }}%)
                                  </span>
                                </span>
                                <span class="estimate-value right-margin-10" title="Current price" v-else>NA</span>

                                <div class="flex flex-wrap" style="margin-top: -4px">
                                  <div class="input-label-gray" style="font-size: 11px" v-if="reco_data.stock.current_datetime">
                                    {{ reco_data.stock.current_datetime | stock_live_price_date_filter }}

                                    <span>
                                      <img class="info-Logo cursor-pointer" src="../../assets/images/Fundamental analysis.svg" alt @click="openPopupForMoreDetails(reco_data)" />

                                       <el-popover
  placement="bottom"
  trigger="click"
  width="300"
  popper-class="custom-popover-shadow"
  style="margin-bottom: 4px"
>
  <img
    class="info-Logo cursor-pointer"
    src="../../assets/images/Logic.svg"
    alt
    slot="reference"
  />

  <div class="recommendation-details">
    <el-collapse v-model="activeLogicSections" accordion>
      <!-- Discovery Category & Logic -->
      <el-collapse-item name="1" title="Discovery Category & Logic">
        <div
          v-if="reco_data.category_stamp && reco_data.category_stamp.length"
          style="border-bottom:1px solid rgb(231, 231, 231); margin-bottom: 10px; padding-top: 5px;"
        >
          <div class="section-subtitle">Category</div>
          <div class="category-list">
            <span
              v-for="(stamp, index) in reco_data.category_stamp"
              :key="index"
              class="category-chip"
            >
              {{ stamp }}
            </span>
          </div>
        </div>

        <div
          v-if="reco_data.report && reco_data.report.some(item => item.files && item.files.length)"
        >
          <div
            v-for="(item, item_index) in reco_data.report"
            :key="item_index"
          >
            <div
              v-for="(attachment, attachment_index) in item.files"
              :key="attachment_index"
              class="attachment-block"
            >
              <div class="attachment-header">
                <div class="attachment-title">
                  Attachments {{ attachment_index + 1 }}
                </div>
                <div
                  class="download-link"
                  @click="downloadAttachment(attachment)"
                >
                  <i class="el-icon-download"></i> Download
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="reco_data.logic_description || (reco_data.logic_tags && reco_data.logic_tags.length)"
          class="section-block"
          :style="(reco_data.edit_description || reco_data.exit_description) ? 'border-bottom:1px solid rgb(231, 231, 231); padding-bottom: 10px; padding-top: 5px;' : 'padding-bottom: 10px; padding-top: 5px;'"
        >
          <div class="section-subtitle">Logic</div>
          <div class="logic-description">
            {{ reco_data.logic_description }}
          </div>
          <div
            class="logic-tags"
            v-if="reco_data.logic_tags && reco_data.logic_tags.length"
          >
            <span
              v-for="(tag, i) in reco_data.logic_tags"
              :key="i"
              class="logic-tag"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </el-collapse-item>

      <!-- Updated Logic -->
      <el-collapse-item
        name="2"
        title="Updated Logic"
        v-if="reco_data.edit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.edit_description }}
          </div>
        </div>
      </el-collapse-item>

      <!-- Exit Logic -->
      <el-collapse-item
        name="3"
        title="Exit Logic"
        v-if="reco_data.exit_description"
      >
        <div class="section-block">
          <div class="logic-description">
            {{ reco_data.exit_description }}
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</el-popover>
                                    </span>
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </div>
                          <div class="remaining-potential top-margin-15">
                            <label class="input-label-bold-gray">Remaining Target</label>
                            <el-popover placement="bottom" title="Potential" width="200" trigger="click" content="It is calculated on basis of minimum investment of Rs. 1 Lakh which can incurred on the basis of last tracked price">
                              <img class="info-Logo cursor-pointer" src="../../assets/images/Info.svg" alt slot="reference" style="height: 12px; top: 2px; right: 5px" />
                            </el-popover>
                            <div class="label-md-bold-black top-margin-5">
                              <span class="remaining-potential-btns">
                                <span style="margin-left: 5px">
                                  <span v-if="reco_data.reco_status == 'YET TO LIVE'">{{ reco_data.max_profit_in_percentage }}%</span>
                                  <span v-else-if="reco_data.reco_status == 'TARGET ACHIEVED'">0%</span>
                                  <span v-else>{{ !reco_data.potential_as_of_current_date ? 0 : reco_data.potential_as_of_current_date }}%</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col :xs="9" :sm="9" :md="12" :lg="12" :xl="12" class="performance-circle">
                      <el-row class="performance-accuracy-container">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                          <div class="performance-section performance-section-two">
                            <el-tooltip class="item" effect="dark" :disabled="reco_data.reco_status == 'YET TO LIVE'" :content="reco_data.reco_status == 'TARGET ACHIEVED' ? 100 + '%' : reco_data.performance + '%'" placement="top">
                              <NewCircleProgress :transitionDuration="5000" :radius="35" :strokeWidth="8" :strokeColor="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance > 0 ? '#079e3e' : (reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'UPDATED' || reco_data.reco_status == 'CLOSED' || reco_data.reco_status == 'EXIT' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.performance < 0 ? '#d60918' : '#079e3e'" :value="getPerformanceWheelValue(reco_data) > 100 ? 100 : getPerformanceWheelValue(reco_data)">
                                <div class style="font-size: 0.6rem; color: #000; font-weight: 600; width: 70px">
                                  {{ reco_data.reco_status }}
                                </div>
                                <template v-slot:footer></template>
                              </NewCircleProgress>
                            </el-tooltip>

                            <div class="progress-description">
                              <div class="input-label-gray">
                                <!-- if reco status is closed then displayed closed date to stop date calculation -->
                                <span v-if="reco_data.reco_status == 'CLOSED'">
                                  As on
                                  {{ reco_data.closed_date_time | formatDate }}
                                </span>

                                <!-- if reco status is target achieved then displayed achieved date to stop date calculation -->
                                <span v-if="reco_data.reco_status == 'TARGET ACHIEVED'">
                                  As on
                                  {{ reco_data.target_achieved_date_time | formatDate }}
                                </span>

                                <!-- if reco status is target not achieved then displayed result_date_time to stop date calculation -->
                                <span v-if="reco_data.reco_status == 'TARGET NOT ACHIEVED'">
                                  As on
                                  {{ reco_data.target_not_achieved_date_time | formatDate }}
                                </span>

                                <span v-if="reco_data.reco_status == 'STOP LOSS TRIGGERED'">
                                  As on
                                  {{ reco_data.stop_loss_triggered_date_time | formatDate }}
                                </span>

                                <!--if only reco status is live, yet to live and updated -->
                                <span v-if="reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'UPDATED'">As on {{ reco_data.stock.today | formatDate }}</span>

                                <!-- reco duration section -->
                                <!-- if reco status is live, yet to live, stop loss triggered and current date is reco date then displayed -->
                                <div class="" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED') && reco_data.difference_in_days == 0">(Today)</div>

                                <!-- if only reco status is live, yet to live, stop loss triggered, target achieved, target not achieved and current date is greater than reco date -->
                                <div class="" v-if="(reco_data.reco_status == 'LIVE' || reco_data.reco_status == 'YET TO LIVE' || reco_data.reco_status == 'STOP LOSS TRIGGERED' || reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days != 0">
                                  ({{ reco_data.difference_in_days }}
                                  <span v-if="reco_data.difference_in_days > 1">Days</span>
                                  <span v-else>Day</span>
                                  from reco date)
                                </div>

                                <!-- if reco status is updated and current date is reco date then displayed -->
                                <div class="" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days == 0">(Updated Today)</div>

                                <!-- if reco status is updated and current date is greater than reco date -->
                                <div class="" v-if="reco_data.reco_status == 'UPDATED' && reco_data.difference_in_days != 0">
                                  ({{ reco_data.difference_in_days }}
                                  <span v-if="reco_data.difference_in_days > 1">Days</span>
                                  <span v-else>Day</span>
                                  from updated reco date)
                                </div>

                                <!-- if reco status is target achieved, target not achieved on same day (reco published day) then displayed -->
                                <div class="" v-if="(reco_data.reco_status == 'TARGET ACHIEVED' || reco_data.reco_status == 'TARGET NOT ACHIEVED') && reco_data.difference_in_days == 0">(On Reco date)</div>

                                <!-- if recos closed or target achieved on updated reco day then displayed -->
                                <div class="" v-if="reco_data.has_close_reco && reco_data.difference_in_days == 0 && reco_data.reco_status == 'TARGET ACHIEVED'">(On Updated Reco date)</div>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>

                <div class="flex top-margin-10" style="justify-content: space-between">
                  <div class="period-type-tag" style="width: 47%" :class="[reco_data.reco == 'Buy' ? 'active-period-type-tag' : reco_data.reco == 'Sell' ? 'active-period-type-tag-red' : reco_data.reco == 'Hold' ? 'active-period-type-tag-yellow' : 'period-type-tag']">
                    <img style="width: 16px; margin-right: 3px; position: relative; top: 3px" src="../../assets/images/two-arrows.png" alt="" />
                    {{ reco_data.reco }}
                  </div>
                </div>
              </div>

              <div class="flex flex-center">
                <span class="input-label-gray cursor-pointer" style="color: red; margin: 8px 0; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-if="reco_data.toggle_more_info">
                  Less details
                  <i class="el-icon-arrow-up"></i>
                </span>

                <span class="input-label-gray cursor-pointer" style="color: red; margin: 8px 0 0; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-else>
                  {{ reco_data.user.first_name ? reco_data.user.first_name + "'s" : reco_data.user.full_name ? reco_data.user.full_name.split(' ')[0] + "'s" : '' }}
                  reco details
                  <i class="el-icon-arrow-down"></i>
                </span>
              </div>

              <!-- <div class="faded-border-bottom">&nbsp;</div> -->

              <div v-if="reco_data.toggle_more_info">
                <StockProgress :stockData="reco_data" :selectedIndex="index" :segment="'Equity'"></StockProgress>
              </div>
            </div>

            <PremiumLock v-if="index != 0"></PremiumLock>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="sentiment-card-dialog tabs-dialog">
      <el-dialog :visible.sync="showSentimentCard" :before-close="clearTechnicalDataWidget">
        <div style="padding: 20px">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="Market Sentiment" name="Market Sentiment">
              <div class="tab-market-sentiment">
                <MarketSentimentCard v-if="selectedSymbol" :stock_code="selectedSymbol" :key="selectedSymbol" style="border: 1px solid #dbdbdb; border-radius: 8px"></MarketSentimentCard>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Fundamental Data" name="Fundamental Data">
              <iframe :src="'https://stocks.tickertape.in/' + selectedSymbol + '?broker=stockants'" width="100%" height="350px"></iframe>
            </el-tab-pane>
            <el-tab-pane label="Technical Data" name="Technical Data">
              <VueTradingView
                class="top-margin-15"
                v-if="selectedSymbol"
                :options="{
                  symbol: 'BSE:' + selectedSymbol,
                  theme: 'light',
                  autosize: false,
                  allow_symbol_change: true,
                  autosize: true,
                  locale: 'in',
                  style: 3,
                  interval: '1D',
                }"
                style="height: 350px"
              />
              <div class="tradingview-widget-copyright top-margin-10" v-if="selectedSymbol">
                <a href="https://in.tradingview.com/" rel="noopener nofollow" target="_blank">
                  <span class="blue-text">{{ selectedSymbol }} stock chart by TradingView</span>
                </a>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dialog>
    </div>

    <div class="sentiment-card-dialog stock-profile-dialog">
      <el-dialog :visible.sync="isStockProfilePopupVisible" :show-close="false" :before-close="clearTradingViewWidget">
        <!-- TradingView Widget Container -->
        <div class="tradingview-widget-container" ref="tradingviewContainer">
          <div class="tradingview-widget-container__widget"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../../networkConfig';
import NewCircleProgress from './../NewCircularProgress';
import { filterCallBack } from '../../mixins/filter';
import { some } from 'lodash';
import { HelperNetworkCallBack } from '../../mixins/Helper';
import { screenSize } from '../../mixins/ScreenSize.js';
import MarketSentimentCard from './../StockAntsLiteWidgets/WidgetSentimentCard.vue';
import StockProgress from './../StockProgressBarComponent.vue';
import PremiumLock from './../StockAntsLiteWidgets/WidgetLock.vue';
import VueTradingView from 'vue-trading-view/src/vue-trading-view';

export default {
  name: 'WidgetRecoCard',

  props: ['recommendationsList', 'recoType'],

  mixins: [filterCallBack, HelperNetworkCallBack, screenSize],

  components: {
    NewCircleProgress,
    StockProgress,
    MarketSentimentCard,
    PremiumLock,
    VueTradingView,
  },

  data() {
    return {
      serverHostName: serverHostName,
      websiteUserType: {},
      currentEnvironment: {},
      showSentimentCard: false,
      activeTab: 'Market Sentiment',
      selectedSymbol: '',
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      isStockProfilePopupVisible: false,
      activeLogicSections: '',
    };
  },

  watch: {},

  methods: {
    loadTradingViewWidget(symbol) {
      this.isStockProfilePopupVisible = true; // Show the popup

      // Dynamically load the TradingView widget
      this.$nextTick(() => {
        this.loadTradingViewWidgetContent(symbol);
      });
    },

    // Method to load TradingView widget content dynamically
    loadTradingViewWidgetContent(symbol) {
      const container = this.$refs.tradingviewContainer;

      if (!container) {
        console.error('TradingView container not found');
        return;
      }

      // Clear existing widget
      container.innerHTML = '';

      // Create a new script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-profile.js';
      script.innerHTML = JSON.stringify({
        width: '100%',
        height: 'auto',
        isTransparent: false,
        colorTheme: 'light',
        symbol: 'BSE:' + symbol,
        locale: 'en',
      });

      // Append the script to the container
      container.appendChild(script);
    },

    // Clear the widget content when the dialog is closed
    clearTradingViewWidget() {
      const container = this.$refs.tradingviewContainer;

      if (container) {
        container.innerHTML = ''; // Clear the widget
      }
      this.isStockProfilePopupVisible = false;
    },

    clearTechnicalDataWidget() {
      this.selectedSymbol = ''; // Clear previous symbol
      this.$nextTick(() => {
        this.selectedSymbol = ''; // for fully cleared
      });

      this.showSentimentCard = false;
      this.activeTab = 'Market Sentiment';
    },

    openPopupForMoreDetails(data) {
      this.selectedSymbol = data.stock.symbol;
      this.activeTab = 'Market Sentiment';
      this.showSentimentCard = true;
    },

    downloadAttachment(attachment_link) {
      if (attachment_link) {
        window.open(`${serverHostName}${attachment_link}`, '_blank');
      }
    },

    openStockWidgetDialog(stock_code) {
      this.$emit('openStockWidget', stock_code);
    },

    getPerformanceWheelValue(reco_data) {
      if (reco_data.performance == null || reco_data.performance == '') {
        return String(0);
      } else if (reco_data.reco_status == 'TARGET ACHIEVED') {
        return String(100);
      } else if (reco_data.performance < 0) {
        return String(reco_data.performance);
      }

      let v = String(((reco_data.performance / reco_data.target_potential) * 100).toFixed(2));
      if (v > 100) {
        return 100;
      }

      return v;
    },

    //toogle more information
    toggleMoreInfo(index) {
      this.recommendationsList[index].toggle_more_info = !this.recommendationsList[index].toggle_more_info;
    },

    //api called to get market expert list to compare reco with market expert
    getMarketExpertList(reco_id, index) {
      serverAddr
        .get(`/recommendation/v1/compare_reco_with_other_expert/${reco_id}`)
        .then((response) => {
          if (response.data.status) {
            this.recommendationsList[index].expert_list = response.data.data;
          } else {
            this.recommendationsList[index].expert_list = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.WidgetRecoCard {
  .box-card {
    border-radius: 8px !important;
  }

  .period-type-tag {
    text-align: center;
    border-radius: 8px;
    padding: 8px 10px 10px;
    margin: 0 auto;
    color: #409eff;
    border: 1px solid;
    min-width: 50px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
  }

  .active-period-type-tag {
    border-color: #079e3e;
    background-color: #079e3e;
    color: #fff !important;
  }

  .active-period-type-tag-yellow {
    border-color: #e2ba00;
    background-color: #e2ba00;
    color: #fff !important;
  }

  .active-period-type-tag-red {
    border-color: #d60918;
    background-color: #d60918;
    color: #fff !important;
  }

  .download-btn {
    font-size: 8px;
    padding: 1px 5px 2px;
  }

  .more-btn {
    font-size: 9px;
    color: #2488fe;
    font-weight: 600;
  }

  .remaining-potential-desktop {
    display: flex;
    justify-content: center;
  }

  .roi-card-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .roi-card {
      font-size: 0.7rem;
      padding: 0px 5px;
      margin: 0 7px;
      text-align: left;

      p {
        margin: 5px;
      }

      .input-label-bold-gray {
        margin-bottom: 10px;
      }
    }
  }

  .remaining-potential-btns {
    background: #e9f9eff7;
    padding: 4px 5px;
    color: #079e3e;
    border-radius: 5px;
    margin-right: 3px;
  }

  .Mobile-card {
    display: none;
  }

  .reco-section {
    /* text-align: center; */
    display: flex;
    justify-content: left;
  }

  .box-card-two {
    .reco-date-mobile,
    .mobile-view {
      display: none;
    }

    .first-sec {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .second-sec {
      margin-top: 15px;

      .stock-title {
        font-size: 18px;
      }

      .estimate-value {
        font-size: 16px !important;
      }
    }

    .third-sec {
      .input-label-gray {
        font-size: 10px;
      }

      .reco-details-section {
        display: flex; // align-items: center;
        align-items: flex-start;
      }

      .right-border {
        border-right: 1px solid #e9e9e9;
        margin-right: 20px;
      }

      .small-box {
        // height: 50px;
        // position: relative;
        // top: 20px;
      }
    }
  }

  .mobile-blocks {
    display: none;
  }

  .reco-type-potential-block {
    text-align: center;
    margin: 0 auto;

    .reco-type-box {
      margin-top: 10px;
      background-color: #ffff;
      box-shadow: 1px 1px 3px 1px #00000026;
      font-size: 12px;
      display: flex;
      justify-content: space-around;
      padding: 6px 2px;
      border-radius: 5px;
      color: #303133;
      width: 200px;
    }
  }

  .mobile-blocks {
    display: none;
  }

  .reco-type-potential-block {
    text-align: center;
    margin: 0 auto;

    .reco-type-box {
      margin-top: 10px;
      background-color: #ffff;
      box-shadow: 1px 1px 3px 1px #00000026;
      font-size: 12px;
      display: flex;
      justify-content: space-around;
      padding: 6px 2px;
      border-radius: 5px;
      color: #303133;
      width: 200px;
    }
  }

  .reco-btns {
    max-width: 50px;
    margin: 10px 0 !important;
    display: block;
  }

  .reco-btns-trade {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .reco-details {
    // padding-bottom: 20px;

    .antestimate-block {
      background: #2d2e8d;
      color: #ffff;
      border-radius: 5px;
      width: 88%;
      margin-bottom: 10px;
    }
  }

  .target-period-section {
    display: flex !important;
    justify-content: center;
    border-right: 1px solid #ddd;
  }

  .target-period-details {
    display: block;
  }

  .performance-section {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
    text-align: center;
    border-right: 1px solid #ddd;
  }

  .progress-description {
    // height: 40px;
    text-align: left;
    margind-top: 7px;
  }

  .progress-bar-legends {
    width: 12px;
    height: 12px;
    background-color: #a29eab;
    border-radius: 3px;
    margin: 0 10px 0 0;
  }

  .legends-text {
    font-size: 0.8rem;
    margin-right: 5px;
  }

  .accuracy-section {
    text-align: center;
    display: flex;
    flex-direction: column; // padding: 0!important;
  }

  .antestimate-block {
    text-align: center;
    border-radius: 20px;
    border: 1px solid #333;
    font-size: 0.8rem;
    font-weight: 500;
    color: #000;
    padding: 5px 10px;
    width: fit-content;
    margin: 5px auto;
  }

  .faded-border-bottom {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#f1f1f1), to(#fff));
  }

  .timer {
    align-self: center;
  }

  .cross-icon {
    color: #ddd;
    font-size: 20px;
  }

  .cross-icon:hover {
    font-size: 20px;
    color: black;
    cursor: pointer;
  }

  .border-bottom-gray {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  .user-profile-pic {
    height: 38px;
    width: 38px;
    border-radius: 50px;
    margin-right: 10px;
    object-fit: cover;
  }

  .bottom-margin-10 {
    margin-bottom: 8px;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
  }

  .reco-more-details-container {
    display: flex;
    justify-content: space-around;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 18px;
  }

  .active-period-type-tag:focus,
  .period-type-tag:focus {
    outline: none;
  }

  .vertical-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .info-Logo {
    width: 22px;
    height: 22px;
    padding: 0px 2px 0px 3px;
    position: relative;
    top: 4px;
  }

  .expertPerformanceListSection {
    border-top: 1px dashed #ddd;
    padding: 5px 0 0;
    margin-top: 10px;
  }

  .progress-bar-legends-section {
    display: flex;
    justify-content: center;
    text-align: center;
  }

  //media queries
  @media screen and (max-width: 1284px) {
    .performance-section-two {
      display: block;
      text-align: center;
      border-right: none;

      .progress-description {
        text-align: center;
        padding: 0;
        margin-top: 0;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .reco-section {
      display: block;
      margin: 10px 0 0 0;
    }

    .reco-btn-section {
      display: flex;
    }

    .reco-btn-section .reco-btns {
      margin: 0 10px 0 0 !important;
    }

    .target-period-section {
      margin: 20px 0 0 0;
      display: flex !important;
      justify-content: space-between;
      border-right: none;
    }

    .target-period-details {
      display: flex;
      justify-content: center;
      width: 100%;
      /* border-bottom: 1px solid #ddd; */
      padding-bottom: 10px;
      flex-wrap: wrap;
    }

    .period-contents {
      padding: 0 20px 0 0;
    }
  }

  @media screen and (min-width: 993px) {
    .isMobileView {
      display: none;
    }

    .target-period-section-border {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    // .box-card-two .third-sec .small-box {
    //   top: 40px;
    // }

    .isDeskTopView {
      display: none;
    }

    .isMobileView {
      // margin-top: 30px;
    }

    .performance-accuracy-container {
      margin-top: 20px;
    }

    .mobile-blocks {
      display: block;
    }

    .target-period-box {
      background-color: #f6f6f6;
      padding: 8px 12px;
      border-radius: 5px;
      box-shadow: 1px 1px 3px 1px #00000026; // width: 120px;
      margin: 7px;
    }

    .desktop-blocks {
      display: none;
    }
  }

  @media screen and (max-width: 680px) {
    .box-card-two {
      .reco-date-mobile img {
        width: 15px !important;
        margin: 0;
      }

      .inner-card {
        // line-height: 0.7rem;
      }

      .label-xs-bold {
        font-size: 10px;
      }

      .performance-accuracy-container {
        margin-top: 0px;
      }

      .input-label-gray {
        font-size: 11px;
      }

      .mobile-view {
        display: block;
      }

      .desktop-view {
        display: none;
      }

      .third-sec {
        // .reco-details-section {
        //   display: unset;
        // }
        .performance-circle {
          // width: 100%;
        }

        .input-label-bold-gray {
          font-size: 10px;
        }

        .input-label-gray {
          font-size: 10px !important;
        }

        .label-md-bold-black {
          font-size: 12px !important;
        }

        // .small-box {
        //   top: 10px;
        // }
      }

      .second-sec {
        margin-top: 10px;

        .stock-title {
          font-size: 16px;
        }

        .code-title {
          font-size: 0.6rem;
        }

        .estimate-value {
          font-size: 14px !important;
        }
      }
    }
  }

  @media screen and (max-width: 575px) {
    .info-Logo {
      width: 18px;
    }

    .target-period-details {
      justify-content: center;
    }

    .reco-type-potential-block .reco-type-box {
      width: 170px;
    }

    .period-contents {
      padding: 0 0px 0 0;
    }

    .performance-section {
      padding: 0 5px;
    }

    .progress-bar-legends-section {
      display: block;
    }

    .accuracy-section {
      padding: 0 5px !important;
    }

    .faded-border-bottom {
      display: block;
      border: none;
      color: #fff;
      height: 1px;
      background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 250, from(#ddd), to(#fff));
    }
  }

  @media screen and (max-width: 550px) {
    .box-card-two {
      .reco-date-desktop {
        display: none;
      }

      .reco-date-mobile {
        display: block;
      }

      .third-sec {
        // margin: 10px 0;
        .right-border {
          margin-right: 10px;
        }

        // .small-box {
        //   height: 80px;
        // }
      }

      // .remaining-potential {
      //   margin-top: 10px;
      // }
    }

    .accuracy-section {
      margin-top: 30px;
    }

    .reco-type-potential-block .reco-type-box {
      font-size: 10px;
      width: 120px;
      padding-bottom: 0;
    }

    .profile-antestimateSection {
      flex-wrap: wrap;
    }

    .reco-details .antestimate-block {
      margin-top: 20px; // margin-left: 30px;
    }

    .reco-details .antestimate-mobile {
      margin-left: 30px;
    }

    .target-period-box {
      padding: 8px 7px;
      margin: 5px;

      .input-label-bold-gray {
        font-size: 11px;
      }

      .label-xs-bold {
        font-size: 12px;
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.WidgetRecoCard .sentiment-card-dialog {
  .tab-market-sentiment {
    .stock-details {
      margin: 15px;
    }

    .sentiment-options {
      display: none;
    }

    .el-card__body,
    .el-main {
      padding: 0;
    }

    .box-card {
      margin: 0;
    }
  }

  .el-dialog {
    margin-top: 100px;
    width: 550px;
    border-radius: 8px;
  }

  .el-dialog__body,
  .el-dialog__header {
    padding: 0px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    z-index: 2;
    position: relative;
  }

  .box-card {
    border-radius: 10px !important;
    border: none;
    box-shadow: none;
  }

  .box-card-two {
    margin: 5px;
  }

  .employee-select-box .el-input--mini .el-input__inner {
    height: 25px;
    border-radius: 8px;
    text-transform: capitalize;
  }

  .el-progress-bar {
    padding: 0;
  }

  .el-progress__text {
    display: none;
  }

  .vuejs-countdown .digit {
    font-size: 28px;
  }

  .el-checkbox__inner {
    border-radius: 4px;
  }
}

.WidgetRecoCard .sellDialogue {
  .el-dialog {
    width: 370px;
    border-radius: 8px;
  }

  p {
    word-break: normal;
  }

  .el-dialog__body {
    padding: 20px 15px;
  }

  .el-dialog__header {
    padding: 0;
  }
}

.WidgetRecoCard .tabs-dialog {
  .el-dialog {
    width: 700px;
  }
}

.el-select-dropdown__list li {
  font-size: 12px;
}

.el-select-dropdown__item:hover {
  color: $primary-theme-color !important;
  background-color: #f5f7fa !important;
}

.el-select-dropdown__item.selected {
  color: $primary-theme-color;
}

.el-popover {
  background-color: #fff !important;
  border: none !important;
}

.recommendation-details {
  .el-collapse-item__header {
    font-weight: 600;
    font-size: 14px;
    padding: 12px;
    background: #fff;
    border-bottom: 1px solid #eee;
    border-radius: 8px;
    color: #000;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    border-bottom:1px solid rgb(231, 231, 231) !important;

    .el-collapse-item__arrow {
      margin-left: auto !important;
      font-size: 14px !important;
      color: #909399 !important;
      transition: transform 0.3s ease !important;
      display: inline-block !important;
    }

    &.is-active .el-collapse-item__arrow {
      transform: rotate(90deg) !important;
    }
  }

  .section-subtitle {
    font-weight: 600;
    font-size: 13px;
    padding-left: 12px;
    color: #000;
    margin-bottom: 8px;
  }

  .category-list {
    display: flex;
    flex-wrap: wrap;
  }

  .category-chip {
    background: #fff;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 500;
    margin: 0 10px 10px 12px;
    color: black;
    border: 1px solid #ccc;
  }

  .attachment-block {
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 6px;
    margin-bottom: 12px;
  }

  .attachment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 12px;
  }

  .attachment-title {
    font-size: 13px;
    font-weight: 600;
    color: #000;
  }

  .download-link {
    font-size: 13px;
    color: #ef3f3f;
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      margin-right: 4px;
      font-size: 0.75rem;
    }
  }

  .logic-description {
    font-size: 13px;
    color: #555;
    max-height: 100px;
    overflow-y: auto;
    margin: 5px 0 12px;
    padding-left: 12px;
  }

  .logic-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-left: 12px;
  }

  .logic-tag {
    background-color: #ef3f3f;
    color: white;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 700;
  }

  .section-block {
    // optional padding
  }
}

@media screen and (max-width: 720px) {
  .WidgetRecoCard .tabs-dialog {
    .el-dialog {
      width: 95%;
    }
  }
}

@media screen and (max-width: 600px) {
  .WidgetRecoCard {
    .sentiment-card-dialog {
      .el-dialog {
        margin-top: 20px;
        width: 95%;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .WidgetRecoCard .sellDialogue {
    .el-dialog {
      width: 90%;
    }
  }

  .WidgetRecoCard .box-card {
    .timer .day,
    .timer .hour,
    .timer .min,
    .timer .sec {
      font-size: 17px;
    }
  }

  .WidgetRecoCard .box-card {
    .el-card__body {
      padding: 12px;
    }
  }
}
</style>
